import { isNotNil } from '@wrisk/ui-components'

import { Data } from '../../../../domain'
import { ValidationFunctions } from '../types'

export const vehicleKBA: ValidationFunctions = {
  _self: {
    required: (option: boolean) => (value: Data | null | undefined) =>
      !option ? true : isNotNil(value),
  },
}
